// JSX field renderers for TaskBulkEditModal.
import { TextField, FormControl, Select, MenuItem, Box } from '@mui/material';
import { translate as t } from '@/i18n/useT';
import { BulkEditFieldGroup } from './BulkEditFieldGroup';
import { BulkEditTagField } from './TaskBulkEditTagField';
import { BulkEditDurationField } from './TaskBulkEditDurationField';

const BULK_EDIT_DATE_ID = 'bulk-edit-date';
const BULK_EDIT_STATUS_LABEL_ID = 'bulk-edit-status-label';
const BULK_EDIT_STATUS_ID = 'bulk-edit-status';
const BULK_EDIT_PERSON_ID = 'bulk-edit-person';

const renderDateField = (date, setDate, untouchedSymbol) => (
  <BulkEditFieldGroup
    label={t('taskbulkeditmodal.setDate', 'Set Date')}
    htmlFor={BULK_EDIT_DATE_ID}
  >
    <TextField
      id={BULK_EDIT_DATE_ID}
      type="date"
      value={date === untouchedSymbol ? '' : date}
      onChange={(e) => setDate(e.target.value)}
      fullWidth
    />
  </BulkEditFieldGroup>
);

const renderStatusSelect = (status, setStatus, untouchedSymbol) => (
  <BulkEditFieldGroup
    label={t('taskbulkeditmodal.setStatus', 'Set Status')}
    labelId={BULK_EDIT_STATUS_LABEL_ID}
  >
    {/* Waarde bewust Engels: tests/bulk-edit.spec.js selecteert
        modal.getByLabel(/Set Status/i) op deze exacte tekst. */}
    <FormControl fullWidth>
      <Select
        id={BULK_EDIT_STATUS_ID}
        labelId={BULK_EDIT_STATUS_LABEL_ID}
        displayEmpty
        value={status === untouchedSymbol ? '' : status}
        onChange={(e) => setStatus(e.target.value)}
        renderValue={(selected) => {
          if (!selected) {
            return t('taskbulkeditmodal.noChange', "Don't change");
          }
          if (selected === 'Active') {
            return t('taskform.statusActive', 'Active');
          }
          if (selected === 'Backlog') {
            return t('taskform.statusBacklog', 'Backlog');
          }
          return selected;
        }}
      >
        <MenuItem value="">
          <em>{t('taskbulkeditmodal.noChange', "Don't change")}</em>
        </MenuItem>
        <MenuItem value="Active">{t('taskform.statusActive', 'Active')}</MenuItem>
        <MenuItem value="Backlog">
          {t('taskform.statusBacklog', 'Backlog')}
        </MenuItem>
      </Select>
    </FormControl>
  </BulkEditFieldGroup>
);

const renderPersonField = (person, setPerson, untouchedSymbol) => (
  <BulkEditFieldGroup
    label={t('taskbulkeditmodal.setPerson', 'Set waiting for')}
    htmlFor={BULK_EDIT_PERSON_ID}
  >
    <TextField
      id={BULK_EDIT_PERSON_ID}
      type="text"
      value={person === untouchedSymbol ? '' : person}
      onChange={(e) => setPerson(e.target.value)}
      helperText={
        person === untouchedSymbol
          ? t('taskbulkeditmodal.noChange', "Don't change")
          : ''
      }
      fullWidth
    />
  </BulkEditFieldGroup>
);

export const renderBulkEditFields = (
  fields,
  setFields,
  allProjects,
  allContexts,
  projectDisplayMap,
  contextDisplayMap,
  untouchedSymbol,
) => {
  const updateField = (name) => (value) => {
    setFields((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '1.5rem',
        pt: '1rem',
      }}
    >
      <BulkEditTagField
        kind="project"
        label={t('taskbulkeditmodal.setProject', 'Set Project')}
        value={fields.project}
        onChange={updateField('project')}
        options={allProjects}
        displayMap={projectDisplayMap}
        untouchedSymbol={untouchedSymbol}
      />
      <BulkEditTagField
        kind="context"
        label={t('taskbulkeditmodal.setContext', 'Set Context')}
        value={fields.context}
        onChange={updateField('context')}
        options={allContexts}
        displayMap={contextDisplayMap}
        untouchedSymbol={untouchedSymbol}
      />
      {renderStatusSelect(
        fields.status,
        updateField('status'),
        untouchedSymbol,
      )}
      {renderDateField(fields.date, updateField('date'), untouchedSymbol)}
      <BulkEditDurationField
        duration={fields.duration}
        setDuration={updateField('duration')}
        untouchedSymbol={untouchedSymbol}
      />
      {renderPersonField(fields.person, updateField('person'), untouchedSymbol)}
    </Box>
  );
};
